import { Typography } from '@mui/material';
import useGenericDevice from 'hooks/useGenericDevice';
import type { FC } from 'react';

interface CustomTableCellWithIconProps {
  serial?: string;
}

const DeviceName: FC<CustomTableCellWithIconProps> = ({ serial }) => {
  const friendlyName = useGenericDevice(
    serial,
    state => state?.fna ?? `go-eCharger_${serial}`,
  );

  return <Typography component="span">{friendlyName}</Typography>;
};

export default DeviceName;
